import { persisted } from 'svelte-local-storage-store';
const STORAGE_KEY = 'business-agent-tutorial-enabled';

// 튜토리얼 활성화 상태를 저장하는 persisted 스토어 생성
export const businessAgentTutorialEnabled = persisted<boolean>(STORAGE_KEY, true);
